import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22031cf6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "email-input-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_EditorContent = _resolveComponent("EditorContent");
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _component_FriedFieldSet = _resolveComponent("FriedFieldSet");
    return (_openBlock(), _createBlock(_component_FriedFieldSet, {
        error: _ctx.hasError,
        "error-message": _ctx.t(_ctx.errorMessage),
        class: "input-editor-container",
        onDrop: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop", "prevent"]))
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_FriedIcon, {
                    class: "icon-left",
                    icon: "mail-sign-at",
                    size: _ctx.IconSize.Small
                }, null, 8, ["size"]),
                _createVNode(_component_EditorContent, {
                    class: "email-input",
                    editor: _ctx.editor,
                    spellcheck: "false"
                }, null, 8, ["editor"])
            ]),
            (_ctx.isUpdating)
                ? (_openBlock(), _createBlock(_component_FriedSpinner, {
                    key: 0,
                    class: "updating-spinner",
                    size: 20
                }))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["error", "error-message"]));
}
